module.exports = __webpack_public_path__ + "img/active-quest.92d91366.svg";